/**
 * As classes de tabela e a linha de exportação das folhas de impressão do RH.
 *
 * Papel: aqui ficam as medidas de `.bh-print-table` da origem — o cabeçalho
 * mono de 10px em caixa alta, o corpo de 13px com 14px por 20px de respiro e
 * a coluna numérica mono de 12,5px em negrito — e `linhaDeExportacao`, que
 * escreve o "Exportado em" de toda folha.
 *
 * Como usar: as três folhas do módulo usam estas classes; mudar uma muda as
 * três, que na origem compartilham a mesma folha de estilo.
 */
import { formatarInstante } from '@/shared/lib/formato';

/** O `th` da folha — `.bh-print-table th`. Para a coluna numérica, acrescente `text-right`. */
export const CLASSES_DO_TH_DA_FOLHA =
  'border-b border-linha px-5 py-[11px] text-left font-mono text-[10px] font-semibold tracking-[0.08em] whitespace-nowrap text-texto-fraco uppercase';

/** O `tbody` da folha, que dá a cada `td` a linha de cima e o respiro — `.bh-print-table td`. */
export const CLASSES_DO_CORPO_DA_FOLHA =
  'text-[13px] [&_td]:border-t [&_td]:border-linha [&_td]:px-5 [&_td]:py-3.5';

/** A célula numérica — `.bh-print-table td.num`. */
export const CLASSES_DO_NUMERO_DA_FOLHA =
  'text-right font-mono text-[12.5px] font-bold whitespace-nowrap';

/**
 * A linha "Exportado em" das folhas.
 *
 * @param exportadaEm - O instante do clique, em ISO 8601 com fuso.
 * @returns `Exportado em DD/MM/AAAA às HH:MM`, no horário de Brasília.
 */
export function linhaDeExportacao(exportadaEm: string): string {
  const [data = '', hora = ''] = formatarInstante(exportadaEm).split(' ');
  return `Exportado em ${data} às ${hora}`;
}
